/* @generated from adl module LanguageEngine */

import * as ADL from './runtime/adl';
import * as Buffer from './Buffer';
import * as Path from './Path';

export interface LanguageEngineSourceTree {
  sourceFiles: LanguageEngineSourceFile[];
}

export function makeLanguageEngineSourceTree(
  input: {
    sourceFiles: LanguageEngineSourceFile[],
  }
): LanguageEngineSourceTree {
  return {
    sourceFiles: input.sourceFiles,
  };
}

const LanguageEngineSourceTree_AST : ADL.ScopedDecl =
  {"moduleName":"LanguageEngine","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceFiles","default":{"kind":"nothing"},"name":"sourceFiles","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"LanguageEngine","name":"LanguageEngineSourceFile"}},"parameters":[]}]}}]}},"name":"LanguageEngineSourceTree","version":{"kind":"nothing"}}};

export const snLanguageEngineSourceTree: ADL.ScopedName = {moduleName:"LanguageEngine", name:"LanguageEngineSourceTree"};

export function texprLanguageEngineSourceTree(): ADL.ATypeExpr<LanguageEngineSourceTree> {
  return {value : {typeRef : {kind: "reference", value : snLanguageEngineSourceTree}, parameters : []}};
}

export interface LanguageEngineEvent_SourceFileChange {
  kind: 'sourceFileChange';
  value: SourceFileChange;
}

export type LanguageEngineEvent = LanguageEngineEvent_SourceFileChange;

export interface LanguageEngineEventOpts {
  sourceFileChange: SourceFileChange;
}

export function makeLanguageEngineEvent<K extends keyof LanguageEngineEventOpts>(kind: K, value: LanguageEngineEventOpts[K]) { return {kind, value}; }

const LanguageEngineEvent_AST : ADL.ScopedDecl =
  {"moduleName":"LanguageEngine","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceFileChange","default":{"kind":"nothing"},"name":"sourceFileChange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"LanguageEngine","name":"SourceFileChange"}},"parameters":[]}}]}},"name":"LanguageEngineEvent","version":{"kind":"nothing"}}};

export const snLanguageEngineEvent: ADL.ScopedName = {moduleName:"LanguageEngine", name:"LanguageEngineEvent"};

export function texprLanguageEngineEvent(): ADL.ATypeExpr<LanguageEngineEvent> {
  return {value : {typeRef : {kind: "reference", value : snLanguageEngineEvent}, parameters : []}};
}

export interface SourceFileChange {
  filePath: Path.PathRelFile;
  changes: Buffer.BufferChange[];
  version: number;
}

export function makeSourceFileChange(
  input: {
    filePath: Path.PathRelFile,
    changes: Buffer.BufferChange[],
    version: number,
  }
): SourceFileChange {
  return {
    filePath: input.filePath,
    changes: input.changes,
    version: input.version,
  };
}

const SourceFileChange_AST : ADL.ScopedDecl =
  {"moduleName":"LanguageEngine","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}},{"annotations":[],"serializedName":"changes","default":{"kind":"nothing"},"name":"changes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Buffer","name":"BufferChange"}},"parameters":[]}]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"SourceFileChange","version":{"kind":"nothing"}}};

export const snSourceFileChange: ADL.ScopedName = {moduleName:"LanguageEngine", name:"SourceFileChange"};

export function texprSourceFileChange(): ADL.ATypeExpr<SourceFileChange> {
  return {value : {typeRef : {kind: "reference", value : snSourceFileChange}, parameters : []}};
}

export interface LanguageEngineResult_FileSyntaxHighlighting {
  kind: 'fileSyntaxHighlighting';
  value: FileSyntaxHighlighting;
}

export type LanguageEngineResult = LanguageEngineResult_FileSyntaxHighlighting;

export interface LanguageEngineResultOpts {
  fileSyntaxHighlighting: FileSyntaxHighlighting;
}

export function makeLanguageEngineResult<K extends keyof LanguageEngineResultOpts>(kind: K, value: LanguageEngineResultOpts[K]) { return {kind, value}; }

const LanguageEngineResult_AST : ADL.ScopedDecl =
  {"moduleName":"LanguageEngine","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fileSyntaxHighlighting","default":{"kind":"nothing"},"name":"fileSyntaxHighlighting","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"LanguageEngine","name":"FileSyntaxHighlighting"}},"parameters":[]}}]}},"name":"LanguageEngineResult","version":{"kind":"nothing"}}};

export const snLanguageEngineResult: ADL.ScopedName = {moduleName:"LanguageEngine", name:"LanguageEngineResult"};

export function texprLanguageEngineResult(): ADL.ATypeExpr<LanguageEngineResult> {
  return {value : {typeRef : {kind: "reference", value : snLanguageEngineResult}, parameters : []}};
}

export interface FileSyntaxHighlighting {
  version: number;
}

export function makeFileSyntaxHighlighting(
  input: {
    version: number,
  }
): FileSyntaxHighlighting {
  return {
    version: input.version,
  };
}

const FileSyntaxHighlighting_AST : ADL.ScopedDecl =
  {"moduleName":"LanguageEngine","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"FileSyntaxHighlighting","version":{"kind":"nothing"}}};

export const snFileSyntaxHighlighting: ADL.ScopedName = {moduleName:"LanguageEngine", name:"FileSyntaxHighlighting"};

export function texprFileSyntaxHighlighting(): ADL.ATypeExpr<FileSyntaxHighlighting> {
  return {value : {typeRef : {kind: "reference", value : snFileSyntaxHighlighting}, parameters : []}};
}

export interface LanguageEngineSourceFile {
  filePath: Path.PathRelFile;
  contents: string;
  version: number;
}

export function makeLanguageEngineSourceFile(
  input: {
    filePath: Path.PathRelFile,
    contents: string,
    version: number,
  }
): LanguageEngineSourceFile {
  return {
    filePath: input.filePath,
    contents: input.contents,
    version: input.version,
  };
}

const LanguageEngineSourceFile_AST : ADL.ScopedDecl =
  {"moduleName":"LanguageEngine","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}},{"annotations":[],"serializedName":"contents","default":{"kind":"nothing"},"name":"contents","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"LanguageEngineSourceFile","version":{"kind":"nothing"}}};

export const snLanguageEngineSourceFile: ADL.ScopedName = {moduleName:"LanguageEngine", name:"LanguageEngineSourceFile"};

export function texprLanguageEngineSourceFile(): ADL.ATypeExpr<LanguageEngineSourceFile> {
  return {value : {typeRef : {kind: "reference", value : snLanguageEngineSourceFile}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "LanguageEngine.LanguageEngineSourceTree" : LanguageEngineSourceTree_AST,
  "LanguageEngine.LanguageEngineEvent" : LanguageEngineEvent_AST,
  "LanguageEngine.SourceFileChange" : SourceFileChange_AST,
  "LanguageEngine.LanguageEngineResult" : LanguageEngineResult_AST,
  "LanguageEngine.FileSyntaxHighlighting" : FileSyntaxHighlighting_AST,
  "LanguageEngine.LanguageEngineSourceFile" : LanguageEngineSourceFile_AST
};
